<template>
<section>
<Breadcrumbs main="Settings" title="Change Pin" />
<div id="PinChangeSection" class="container-fluid" v-if="details && userSecurityQuestion && userPhoneNumber">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <!-- Request Form -->
            <div id="RequestFormSection" v-show="step === 1" class="card animated fadeIn">
                <div class="card-body">
                <div v-if="loading" class="loader-12"></div>
                    <form class="theme-form" @submit.prevent="validateform">
                        <div id="FormSection">
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                                <div class="col-sm-9 col-md-6">
                                <select class="form-control" @input="getSecurityId" v-model="form.securityQuestionId" id="securityQuestion" name="name" required>
                                  <option value="">Select Security Question</option>
                                  <option v-for="securityQuestion in userSecurityQuestion" :key="securityQuestion.id" :value="securityQuestion.id">{{securityQuestion.question}}</option>
                                </select>
                              <p v-if="submitted && !$v.form.securityQuestionId.required" class="error__text">Security Question is Required</p>
                                    <!--<v-select @input="getSecurityId" v-model="form.securityQuestionId"  label="question" :reduce="question => question.id" :options="userSecurityQuestion" placeholder="Select a Security Question"></v-select>
                                    <p v-if="submitted && !$v.form.securityQuestionId.required" class="error__text">Security Question is Required</p>
                                    --><span class="text-danger font-small-2">* We need this to verify your Identity</span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                                <div class="col-sm-9 col-md-6">
                                    <input class="form-control" v-model="form.securityAnswer" id="SecurityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                                    <p v-if="submitted && !$v.form.securityAnswer.required" class="error__text">Security Answer is Required</p>
                                    <span @click="showAnswerPin" class="pull-right show-pin">{{answerType === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="OldPin">Old Pin <b class="text-danger">*</b></label>
                                <div class="col-sm-9 col-md-6">
                                    <input class="form-control" @paste.prevent @keypress="isNumber" maxLength="4" min="0" pattern="\d*" v-model="form.oldPin" placeholder="Enter Old Pin *" :type="typeOld" />
                                    <p v-if="submitted && !$v.form.oldPin.required" class="error__text">Old Pin is Required</p>
                                    <span @click="showOldPin" class="pull-right show-pin">{{typeOld === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="NewPin">New Pin <b class="text-danger">*</b></label>
                                <div class="col-sm-9 col-md-6">
                                    <input class="form-control" @paste.prevent @keypress="isNumber" v-model="form.newPin"  maxlength="4" min="0" pattern="\d*" data-val-required="The NewPin field is required." id="NewPin" name="NewPin" placeholder="Enter New Pin *" :type="typeNew" />
                                    <p v-if="submitted && !$v.form.newPin.required" class="error__text">New Pin is Required</p>
                                    <span @click="showNewPin" class="pull-right show-pin">{{typeNew === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="ConfirmPin">Confirm Pin <b class="text-danger">*</b></label>
                                <div class="col-sm-9 col-md-6">
                                    <input class="form-control" @paste.prevent @keypress="isNumber" pattern="\d*" v-model="form.confirmPin" maxlength="4" name="ConfirmPin" placeholder="Enter New Pin Again *" :type="typeConfirm" />
                                    <p v-if="submitted && !$v.form.confirmPin.required" class="error__text">Confirm Pin is Required</p>
                                    <p v-if="submitted && !$v.form.confirmPin.sameAsNewPin" class="error__text">Pin does not match</p>
                                    <span @click="showConfirmPin" class="pull-right show-pin">{{typeConfirm === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                            </div>
                            <div class="mb-3 row mt-4">
                                <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label"></label>
                                <div class="col-sm-9 col-md-6">
                                    <button type="submit" class="btn btn-round btn-primary mr-2">
                                        <div v-if="loading">
                                            <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-save me-1"></i> Submit 
                                        </div>
                                      </button>
                                    <button type="button" @click="resetForm" class="btn btn-round btn-outline-danger">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Request Success Response -->
            <div id="RequestSuccessResponseSection" v-show="step === 2" class="card animated fadeIn" style="display:block">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> REQUEST SUCCESSFUL!</h5>
                        <p>Your request has been completed successfully!</p>
                        <!-- <router-link to="/dashboard/default"> -->
                          <a class="btn btn-primary btn-round" @click="goHome">Go To Home<i class="fa fa-home ml-2"></i></a>
                        <!-- </router-link> -->
                    </div>
                </div>
            </div>

            <!-- Request Failure Response -->
            <div id="RequestFailureResponseSection" v-show="step === 3" class="card animated fadeIn" style="display:block">
                <div class="card-body text-center">
                    <img src="@/assets/TAJimages/notification/oops.png" alt="Error Icon image" class="img-fluid mb-2" />
                    <h5 class="text-bold-700 mb-0 text-danger"><i class="feather icon-alert-triangle"></i> ERROR</h5>
                    <p>There was an error processing your request.</p>
                    <p ref="ResponseError" class="text-danger">
                        --
                    </p>
                    <p>
                        <a class="btn btn-danger btn-round" @click="resetForm">Retry<i class="fa fa-refresh ml-2"></i></a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else class="loader-12"></div>
</section>
</template>
<script>
  import { mapState } from 'vuex';
  import { required, sameAs } from 'vuelidate/lib/validators';
  import { decrypt } from '@/_services/encryption';
  export default {
    data:()=>({
      step:1,
      form: {
        securityQuestionId: '',
        securityAnswer: null,
        oldPin: null,
        newPin: null,
        confirmPin: null,
        platform: 1,
      },
      loading: false,
      securityQuestionId: null,
      typeOld: 'password',
      typeNew: 'password',
      typeConfirm: 'password',
      answerType: 'password',
      submitted: false,
      isSecurityQuestion: JSON.parse(localStorage.getItem('isSecurityQuestion')),
      isChangePin: JSON.parse(localStorage.getItem('forceChangePin')),
    }),
    validations: {
      form: {
        securityQuestionId: { required },
        securityAnswer: { required },
        oldPin: { required },
        newPin: { required },
        confirmPin: { required, sameAsNewPin: sameAs('newPin') },
      },
    },
    computed: {
      ...mapState({
        details: state => state.dashboard.dashboardData,
        userSecurityQuestion: state => state.authentication.userSecurityQuestion,
        userPhoneNumber: state => state.dashboard.dashboardData.customerDetails.phoneNumber1,
      }),
      userDetails() {
        return this.details ? this.details.customerDetails.userName : null;
      },
      maskedPhoneNumber: function() {
        let phoneNumber = this.userPhoneNumber;
        let maskedPhoneNumber = phoneNumber.substring(7, 7) + '*******' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);
        return maskedPhoneNumber;
      },
    },
    mounted(){
      this.$store.dispatch('dashboard/getDashboardData').then((response) => {
        if(response.status === 200) {
          this.$store.dispatch('getUserSecurityQuestion', { username: this.userDetails, customerType: 2 });
        }
      });
      if(this.isSecurityQuestion) {
        this.$router.push('/settings/reset-security-question');
      }
      if(this.isChangePin) {
        this.$swal({
          text:`Kindly change your Transaction Pin`,
          showCancelButton: true,
          confirmButtonText: 'Proceed',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn btn-primary',
          confirmButtonClass: 'btn btn-success mr-2',
          buttonsStyling: false,
          type:'info'
        }).then((result) => {
          if(result.value) {
            return;
          } else {
            this.$store.dispatch('logout');
          }
        });
      }
    },
    methods: {
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      showOldPin() {
        this.typeOld = this.typeOld === 'password' ? 'text' : 'password';
      },
      showAnswerPin() {
        this.answerType = this.answerType === 'password' ? 'text' : 'password';
      },
      showNewPin() {
        this.typeNew = this.typeNew === 'password' ? 'text' : 'password';
      },
      showConfirmPin() {
        this.typeConfirm = this.typeConfirm === 'password' ? 'text' : 'password';
      },
      // get security question id
      getSecurityId(event) {
        this.form.securityQuestionId = event.target.value;
      },
      validateform() {
        this.submitted = true;
        const invalid = this.$v.form.$invalid;
        if (!invalid) {
          this.changePin();
        }
      },
      goHome () {
        this.$router.push('/dashboard/default');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      changePin() {
        // dispatch change pin
        this.loading = true;
        this.$store.dispatch('settings/changeTransactionPin', this.form).then(() => {
          localStorage.setItem('forceChangePin', false);
          this.loading = false;
          this.step = 2;
        }).catch((error) => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.loading = false;
          this.step = 3;
          this.$refs.ResponseError.innerHTML = objError.errors[0];
        });
      },
      resetForm() {
        this.step = 1;
        this.form.securityAnswer = null;
        this.form.oldPin = null;
        this.form.newPin = null;
        this.form.confirmPin = null;
        this.securityQuestionId = null;
        this.form.securityQuestionId = '';
      }
    }
  };
</script>
<style>
 .loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.show-pin {
    font-size: 12px;
    color: #E41613;
    cursor: pointer;
}
.error__text {
    color: #E41613;
    margin-bottom: 0;
}
.vs__dropdown-toggle {
  height: 43px !important;
  background-color: #fff !important;
  margin-bottom: 5px !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
  color: #898989 !important;
}
input::placeholder {
  color: #898989 !important;
}
</style>